module.exports = __webpack_public_path__ + "img/rover-service-engineer-bg.fe699077.png";